import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Navigation from '../_components/Navigation';
import Bill from 'Assets/bill.gif';
import { userService } from '../_services';
import { withRouter } from 'Components/withRouter';

class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        userService.logout();

        this.state = {
            emailaddress: '',
            password: '',
            submitted: false,
            loading: false,
            error: ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const { emailaddress, password, returnUrl } = this.state;

        // stop here if form is invalid
        if (!(emailaddress && password)) {
            return;
        }

        this.setState({ loading: true });
        userService.login(emailaddress, password)
            .then(
                user => {
                    const { from } = this.props.router.location.state || { from: { pathname: "/" } };
                    this.props.router.navigate(from);
                },
                error => this.setState({ error, loading: false })
            );
    }

    render() {
        const { emailaddress, password, submitted, loading, error } = this.state;
        return (
        <div>
            <Navigation active="" />
            <div className="jumbotron">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-6 col-lg-offset-3">
                            <div className="text-center h4 font-weight-normal">
                                Welcome to the Deadline Express<br/>
                                Web Booking System<br/>
                                Please use your e-mail address to log in below
                            </div>
                            <h2>Login</h2>
                            <form className="flat" id="login" name="login" onSubmit={this.handleSubmit}>
                                <div className={'form-group' + (submitted && !emailaddress ? ' has-error' : '')}>
                                    <label htmlFor="emailaddress">*Email address</label>
                                    <input type="text" className="form-control" name="emailaddress" value={emailaddress} onChange={this.handleChange} />
                                    {submitted && !emailaddress &&
                                        <div className="help-block">Email address is required</div>
                                    }
                                </div>
                                <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                                    <label htmlFor="password">*Password</label>
                                    <input type="password" className="form-control" name="password" value={password} onChange={this.handleChange} />
                                    {submitted && !password &&
                                        <div className="help-block">Password is required</div>
                                    }
                                </div>
                                <div className="form-group">
                                    <button className="btn btn-dl-green" disabled={loading}>LOGIN</button>
                                    {loading &&
                                        <span className="glyphicon glyphicon-refresh glyphicon-spin padding-lr10 text250" />
                                    }
                                </div>
                                <div className="form-group">
                                    <span>Forgotten your password? 
                                        <Link to="/recover" className="padding-lr10">Click to recover</Link>
                                    </span>
                                </div>
                                {error &&
                                    <div className={'alert alert-danger'}>{error.message || error}</div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

const LoginPageWithRouter = withRouter(LoginPage);

export { LoginPageWithRouter as LoginPage }; 